import { jsx as _jsx } from "react/jsx-runtime";
import { Col, Row } from 'antd/es/grid';
import React, { useMemo } from 'react';
const Grid = ({ children, xxl = 1, xl = 1, lg = 1, md = 1, sm = 1, xs = 1, gutter, margin, className, center = false, fitContent = false, style, }) => {
    const marginBottom = useMemo(() => {
        if (!gutter)
            return 0;
        return typeof gutter === 'number' ? gutter : 0;
    }, [gutter]);
    return (_jsx(Row, { style: Object.assign(Object.assign({}, style), { margin, width: fitContent ? 'fit-content' : '100%' }), className: className, gutter: gutter, justify: !!center ? 'center' : 'start', children: Array.isArray(children) ? (React.Children.toArray(children.map((child, i) => (_jsx(Col, { xl: 24 / xl, md: 24 / md, lg: 24 / lg, sm: 24 / sm, xxl: 24 / xxl, xs: 24 / xs, span: 24, style: { marginBottom }, children: child }, `grid-child-item-${i}`))))) : (_jsx(Col, { xl: 24 / xl, md: 24 / md, lg: 24 / lg, sm: 24 / sm, xxl: 24 / xxl, xs: 24 / xs, span: 24, style: { marginBottom }, children: children })) }));
};
export default Grid;
